import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

// import QueueInputs from './components/QueueInputs';

import { accessLocalStorage, exportSelectAllEndpoints, exportSelectAllQueues, exportCreateQueueMembers, changeViewForms, valuesAnalyze } from '../../../services';

import Loading from '../../Loading/LoadingModule';

import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function MembersQueuesCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [endpoints, setEndpoints] = useState([]);
  const [queues, setQueues] = useState([]);
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  /*
    {
      queueName string
      endpointInit number,
      endpointFinal number,
      priority number,
    }
  */

  const getEndpoints = async () => {
    const endpointsList = await exportSelectAllEndpoints();
    if(endpointsList === undefined) return setLoading(true);
    const fetchedEndpoints = endpointsList.map((element) => element).filter((element) => !isNaN(Number(element.endpoint)));

    setEndpoints(fetchedEndpoints);
    setLoading(false);
  };

  const fetchQueues = async () => {
    const queuesList = await exportSelectAllQueues();
    if(queuesList === undefined) return setLoading(true);
    const elements = queuesList.map((element) => element.queuesselect);
    setQueues(elements);
    setLoading(false);
    return true;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    await getEndpoints();
    await fetchQueues();
  }, []);

  const changeScreen = (check, name) => {
    // changeBorderImputToRedOrNormal(check, name);
    // changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'endpointInit' || name === 'endpointFinal' || name === 'priority') {
      const checkValueIsNumber = checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    } else {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    };
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length >= 4) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const sendDataQueueMembersGenerate = async () => {
    const fetchQueues = await exportCreateQueueMembers(values);

    const result = Object.keys(fetchQueues).length > 0 ? true : false;
    if(result) {
      changeVisibityMessages(false, 'success-create-queuesmembers');
      setTimeout(() => {
        return window.location.reload(true);
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">ADICIONAR RAMAL A FILA</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="success-create-queuesmembers" name="success-create-queuesmembers" className="column is-half is-offset-one-quarter message is-info is-hidden">
            <div className="message-header">
              <p>Sucesso!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#success-create-queuesmembers') }></button>
            </div>
            <div className="message-body">
              Atribuiçao de membros a fila realizada com <strong>sucesso</strong>!
            </div>
          </article>
          <div className="columns mx-2">
            <div className="column is-2 field is-half is-offset-2 has-text-centered">
              <label className="label">Ramal Inicial
                <div className="control">
                  <div name="endpointInit" className="select is-fullwidth">
                    <select className="select" name="endpointInit" onChange={(e) => handleChangeValues(e.target)} >
                      <option value="">Selecione</option>
                      { endpoints.map((element) => <option key={element.endpoint} value={element.endpoint}>{ element.endpoint }</option>) }
                    </select>
                  </div>
                  <p name="endpointInit-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
              </label>
            </div>
            <div className="column is-2 field">
              <label className="label">Ramal Final
                <div className="control">
                  <div name="endpointFinal" className="select is-fullwidth">
                    <select className="select" name="endpointFinal" onChange={(e) => handleChangeValues(e.target)} >
                      <option value="">Selecione</option>
                      { endpoints.map((element) => <option key={element.endpoint} value={element.endpoint}>{ element.endpoint }</option>) }
                    </select>
                  </div>
                  <p name="endpointFinal-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
              </label>
            </div>
            <div className="column is-2 field">
              <label className="label">Fila
                <div className="control">
                  <div name="queueName" className="select is-fullwidth">
                    <select className="select" name="queueName" onChange={(e) => handleChangeValues(e.target)} >
                      <option value="">Selecione</option>
                      { queues.map((queue) => <option key={queue} value={queue}>{ queue }</option>) }
                    </select>
                  </div>
                  <p name="queueName-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
              </label>
            </div>
            <div className="column is-2 field">
              <label className="label">Prioridade
                <div className="control">
                  <input className="input" name="priority" type="number" onChange={(e) => handleChangeValues(e.target)} placeholder="0" />
                  <p name="priority-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
              </label>
            </div>
          </div>
          <div id="button-send-form" name="button-send-form" className="columns mt-3">
            <div className="field column mt-3 is-half is-offset-3 has-text-centered">
              <div className="control">
                <button className="button is-info is-fullwidth mt-3" type="submit" disabled={ disable } onClick={ () => sendDataQueueMembersGenerate() }>
                  <span className="icon">
                    <FontAwesomeIcon icon={ faPhoneSquare } fixedWidth />
                  </span>
                  <span>
                    Adicionar Ramal ao Grupo Atendedor
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default MembersQueuesCreate;
